import { createRouter, createWebHashHistory } from "vue-router";
import login from './module/login'
import course from './module/course'
import publics from './module/public'
import topicsRouter from './module/topics'
import vip from './module/vip'
import timetableRouter from './module/timetable'
import coupons from './module/coupons/index.js'
import ticketAndPresent from './module/ticket-and-present'
import my from './module/my'
import note from './module/note'

const routes = [
  {
    path: "/",
    redirect:'/home'
  },
  {
    path: "/download",
    name: 'download',
    component: _ => import('@/pages/download/index'),
  },
  {
    path: '/home',
    name: 'home',
    meta: {
      title: '招牌'
    },
    component: _ => import('@/pages/home/index'),
  },
  {
    path: "/yanshi",
    name: 'yanshi',
    component: _ => import('@/pages/yanshi/index'),
  },
  {
    path: "/yanshi-jump",
    name: 'yanshi-jump',
    component: _ => import('@/pages/yanshi/jump'),
  },
  ...login,
  ...ticketAndPresent,
  ...course,
  ...publics,
  ...topicsRouter,
  ...vip,
  ...timetableRouter,
  ...coupons,
  ...my,
  ...note,
  {
    path: '/not-found',
    name: 'not-found',
    component: () => import('@/pages/not-found/404'),
    meta: {
      title: '未找到相关页面'
    },
  },
  // 找不到路由跳转到404
  {
    path: '/:pathMatch(.*)',
    redirect: '/not-found'
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes: routes
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    // 如果当前路由有meta值
    document.title = to.meta.title
  } else {
    // 如果没有meta值，就显示默认值
    document.title = ''
  }
  next()
})

// router.onError(error => {
//   const pattern = /Loading chunk (\\w)+ failed/g
//   const isError = error.message.match(pattern)
//   const targetPath = router.history.pending.fullPath
//   if (isError) {
//     router.replace(targetPath)
//   }
// })

export default router;
